// extracted by mini-css-extract-plugin
export default {"background":"deleteModal_background__LtjBl","input":"deleteModal_input__0etNu","button":"deleteModal_button__igfhp"};